import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsm3m } from "../../../../data/projects/M3M/data";

export const M3MAntalya = () => {
  const {
    m3mantalyahills: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsm3m;

  return (
    <>
      <Helmet>
        <title>M3M Antalya Hills, Sector 79, Gurgaon | Luxury Low-Rise Floors with Premium Features</title>

        <meta
          name="description"
          content="Experience luxury living at M3M Antalya Hills, Sector 79, Gurgaon – premium low-rise floors with world-class amenities, lush green landscapes, and seamless connectivity. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="M3M Antalya Hills, M3M Antalya Hills Gurgaon, M3M Antalya Hills Sector 79, low-rise luxury floors Gurgaon, premium homes in Gurgaon, luxury residences in Gurgaon, M3M luxury projects"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/m3m-antalya-hills-sector-79-gurugram"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
